import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGoldCircleCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9.99996 18.3334C5.39758 18.3334 1.66663 14.6024 1.66663 10C1.66663 5.39765 5.39758 1.66669 9.99996 1.66669C14.6023 1.66669 18.3333 5.39765 18.3333 10C18.3333 14.6024 14.6023 18.3334 9.99996 18.3334ZM9.16879 13.3334L15.0614 7.4408L13.8829 6.26229L9.16879 10.9764L6.8118 8.61927L5.63328 9.79785L9.16879 13.3334Z",
			fill: "#F1C347"
		})
	})
});
export default SvgGoldCircleCheck;
